import Link from 'next/link'
import {
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/solid'

import Tooltip from '@/components/common/Tooltip'
import Panel from '@/components/common/Panel'

interface Props {
  className?: string
}

const PlanUsage = (props: Props) => {
  return (
    <div className={`p-4 ${props.className}`}>
      <Panel title="Plan usage">
        <div className="text-sm text-gray-500 dark:text-gray-400 pb-2">
          Your current plan is Essential.
        </div>
        {/* Table of plan usage */}
        <div className="border border-gray-200 dark:border-gray-700">
          <div className="overflow-x-auto">
            {/* row 1/4 */}
            <div className="flex justify-between">
              <div className="min-w-20 flex justify-begin bg-red-400 opacity-50">
                <div className="flex whitespace-nowrap font-semibold bg-yellow-400">
                  Feature
                </div>
              </div>
              <div className="min-w-40 flex justify-end bg-green-400 opacity-50">
                <div className="flex whitespace-nowrap font-semibold text-end bg-yellow-400">
                  Essential
                </div>
              </div>
            </div>
            {/* row 2/4 */}
            <div className="flex justify-between">
              <div className="min-w-20 flex justify-begin bg-red-400 opacity-50">
                <div className="flex whitespace-nowrap bg-yellow-400">
                  Groups
                  <Tooltip message="Maximum of groups reached. Please upgrade to a higher plan if you require more groups.">
                    {/* @@TODO: This is the correct padding and spacing for ExclamationTriangleIcon.
                     * Using ms-[3px] would look nicer, but then the Tooltip is offset (not centered).
                     */}
                    <ExclamationTriangleIcon className="text-orange-500 bg-green-400 w-4 h-4 ms-[x mt-1" />
                  </Tooltip>
                </div>
              </div>
              <div className="min-w-40 flex justify-end bg-green-400 opacity-50">
                <pre data-testid="usage-users">
                  <code className="font-mono flex">
                    <div className="bg-blue-400 min-w-12 text-end">5</div>
                    <div className="bg-green-400 min-w-8 text-center">of</div>
                    <div className="bg-blue-400 min-w-12 text-end">5</div>
                  </code>
                </pre>
                <div className="min-w-4 bg-yellow-400">
                  <Tooltip message="5 used out of 5 maximum (100%).">
                    <InformationCircleIcon className="text-blue-500 bg-green-400 w-4 h-4 ms-[x mt-1" />
                  </Tooltip>
                </div>
              </div>
            </div>
            {/* row 3/4 */}
            <div className="flex justify-between">
              <div className="min-w-20 flex justify-begin bg-red-400 opacity-50">
                <div className="flex whitespace-nowrap bg-yellow-400">
                  Sites
                  <Tooltip message="Maximum of sites exceeded. Overuse grace period granted. Please upgrade to a higher plan. Sites exceeding maximum will be disabled after end of grace period.">
                    <ExclamationCircleIcon className="text-red-500 bg-green-400 w-4 h-4 ms-[x mt-1" />
                  </Tooltip>
                </div>
              </div>
              <div className="min-w-40 flex justify-end bg-green-400 opacity-50">
                <pre data-testid="usage-users">
                  <code className="font-mono flex">
                    <div className="bg-blue-400 min-w-12 text-end">52</div>
                    <div className="bg-green-400 min-w-8 text-center">of</div>
                    <div className="bg-blue-400 min-w-12 text-end">50</div>
                  </code>
                </pre>
                <div className="min-w-4 bg-yellow-400">
                  <Tooltip message="52 used out of 50 maximum (>100%).">
                    <InformationCircleIcon className="text-blue-500 bg-green-400 w-4 h-4 ms-[x mt-1" />
                  </Tooltip>
                </div>
              </div>
            </div>
            {/* row 4/4 */}
            <div className="flex justify-between">
              <div className="min-w-20 flex justify-begin bg-red-400 opacity-50">
                <div className="flex whitespace-nowrap bg-yellow-400">
                  Users
                </div>
              </div>
              <div className="min-w-40 flex justify-end bg-green-400 opacity-50">
                <pre data-testid="usage-users">
                  <code className="font-mono flex">
                    <div className="bg-blue-400 min-w-12 text-end">998</div>
                    <div className="bg-green-400 min-w-8 text-center">of</div>
                    <div className="bg-blue-400 min-w-12 text-end">9000</div>
                  </code>
                </pre>
                <div className="min-w-4 bg-yellow-400">
                  <Tooltip message="998 used out of 9000 maximum (<50%).">
                    <InformationCircleIcon className="text-blue-500 bg-green-400 w-4 h-4 ms-[x mt-1" />
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
          {/* row 2/4 */}

          {/*
                    {/*
                <div className="mx-2 flex min-w-24 whitespace-no-wrap bg-green-400">
                  Sites
                </div>
                    <div className="justify-end">5</div>
                    <div className="justify-end">of</div>
                    <div className="justify-end">5</div>
                <div className="text-end">
                  <Tooltip message="2 used out of 50 maximum.">
                    <InformationCircleIcon className="text-blue-500 w-4 h-4 mt-1 mx-1" />
                  </Tooltip>
                </div>

                <div className="m-1 mx-2 flex">Users</div>
                <pre data-testid="usage-users">
                  <code className="m-1 font-mono">
                    <div className="justify-end">5</div>
                    <div className="justify-end">of</div>
                    <div className="justify-end">5</div>
                  </code>
                </pre>
                <div className="text-end">
                  <Tooltip message="2 used out of 10 maximum.">
                    <InformationCircleIcon className="text-blue-500 w-4 h-4 mt-1 mx-1" />
                  </Tooltip>
                </div>
              </div>
              */}
        </div>
        {/* Key to table plan usage */}
        <div className="text-sm text-gray-500 dark:text-gray-400 pb-2">
          Note: 1 of 5 means 1 used out of 5 maximum.
        </div>
        <div className="text-sm text-gray-500 dark:text-gray-400 pb-2">
          Note: Usage is monitored. A notification will be issued to you at 50%,
          80% and 100% of usage.
        </div>
        <div className="pb-4">
          <Link href="#!">
            <div className="text-blue-600 dark:text-blue-400 hover:underline decoration-2">
              Read more about usage, overuse and grace period
            </div>
          </Link>
        </div>
        <div className="pb-4">
          <Link href="#!">
            <div className="text-blue-600 dark:text-blue-400 hover:underline decoration-2">
              Read more about how to arrange your organization into groups,
              sites and users
            </div>
          </Link>
        </div>
      </Panel>
    </div>
  )
}

export default PlanUsage
